"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileService = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const index_1 = require("./index");
class UserProfileService {
    constructor(log) {
        this.log = log;
        this.__priority = 100;
    }
    init() {
        this.userProfileFetchable = new core_shared_1.IkeFetchableMany(this.log, core_shared_1.IkeRest.createStore(), this.fetchUserProfiles);
        (0, mobx_1.reaction)(() => index_1.Services.Department.current, () => {
            if (!index_1.Services.Route.profilesLoaded) {
                this.userProfileFetchable.fetch().then(() => {
                    index_1.Services.Route.profilesLoaded = true;
                });
            }
            this.userProfileFetchable.reset();
        });
    }
    get list() {
        return this.userProfileFetchable.value;
    }
    get(userId) {
        return this.userProfileFetchable.find('objectId', userId);
    }
    refresh() {
        this.userProfileFetchable.refetch();
    }
    isDepartmentAdmin(userProfile) {
        return userProfile != null && userProfile.role === core_api_1.IkeUserRole.ROOT;
    }
    isDepartmentEditor(userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.EDITOR;
    }
    isDepartmentViewer(userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.VIEWER;
    }
    isDepartmentDownloader(userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.DOWNLOADER;
    }
    isDepartmentDataAdmin(userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.DATA_ADMIN;
    }
    isOneOf(userProfile, userRoles) {
        for (let userRole of userRoles) {
            if (userProfile != null && (userProfile.userLevel === userRole)) {
                return true;
            }
        }
        return false;
    }
    isReadOnly(userProfile) {
        return this.isOneOf(userProfile, [core_api_1.IkeUserRole.VIEWER, core_api_1.IkeUserRole.DOWNLOADER]);
    }
    canExportReports(userProfile) {
        if (this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    }
    canImportCollections(userProfile) {
        if (this.isDepartmentDownloader(userProfile) ||
            this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    }
    canEditForms(userProfile) {
        if (this.isDepartmentDownloader(userProfile) ||
            this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    }
    fetchUserProfiles() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = [];
            const rest = index_1.Services.Department.rest;
            if (rest) {
                const departmentUsers = (yield rest.Department.User.list(null)).results;
                const userProfiles = yield rest.query(rest.Objects.UserProfile)
                    .in('objectId', departmentUsers.map(depUsr => depUsr.userId))
                    .find();
                const userProfileMap = {};
                for (const userProfile of userProfiles) {
                    userProfileMap[userProfile.objectId] = userProfile;
                }
                for (let i = 0; i < departmentUsers.length; i++) {
                    const userProfile = userProfileMap[departmentUsers[i].userId];
                    if (userProfile == null) {
                        continue;
                    }
                    result.push(Object.assign({ role: departmentUsers[i].role, userLevel: departmentUsers[i].userLevel }, userProfile));
                }
            }
            return result;
        });
    }
}
exports.UserProfileService = UserProfileService;
tslib_1.__decorate([
    mobx_1.computed
], UserProfileService.prototype, "list", null);
//# sourceMappingURL=user.profile.service.js.map